/**
 * Process Handlers Configuration
 *
 * Shared configuration and utilities for all process handlers
 */

import { simulateApiDelay } from '../mocks'

/**
 * Configuration for enabling/disabling mocks
 * Use mocks only when explicitly set to 'true'
 */
export const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === 'true'

/**
 * Generic handler that chooses between mocks and cloud functions
 *
 * @param mockFn - Function to call when using mocks
 * @param cloudFn - Function to call when using real Firebase
 * @returns Promise with the result from either mock or cloud function
 */
export const handleRequest = async <T>(mockFn: () => Promise<T>, cloudFn: () => Promise<T>): Promise<T> => {
  if (USE_MOCKS) {
    await simulateApiDelay()
    return mockFn()
  } else {
    return cloudFn()
  }
}

// Log which mode we're using on initialization
